/**
 * Simple is object check.
 * @param item
 * @returns {boolean}
*/
export default function isObject(item) {
  return item &&
    null !== item &&
    'object' === typeof item &&
    !Array.isArray(item);
}



// WEBPACK FOOTER //
// ./app/utils/object/isObject.js